import { ModelBase } from '../../core/model/model-base';
import { User } from './user';

export class ExecutorGroupUser extends ModelBase {
  constructor(dataContext?: any) {
    super();
    if (dataContext) {
      this.id = dataContext.id;
      this.executorGroupId = dataContext.executorGroupId;
      this.webUserId = dataContext.webUserId;
      this.webUser = dataContext.webUser;
    }
  }

  executorGroupId: string;
  webUserId: string;
  webUser: User;
}
